var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7612_25739",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H19V19H3V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7612_25739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7586 18.1973H6.23999C4.89204 18.1973 3.79932 16.9079 3.79932 15.3173V6.67726C3.79932 5.08668 4.89204 3.79726 6.23999 3.79726H15.7586C17.1066 3.79726 18.1993 5.08668 18.1993 6.67726V15.3173C18.1993 16.9079 17.1066 18.1973 15.7586 18.1973Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1993 8.19844C10.1993 8.8612 9.66208 9.39844 8.99932 9.39844C8.33656 9.39844 7.79932 8.8612 7.79932 8.19844C7.79932 7.53571 8.33656 6.99844 8.99932 6.99844C9.66208 6.99844 10.1993 7.53571 10.1993 8.19844Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8 15L12.5 11.8L10.3 13.9333L9.2 12.8667L7 15",
    stroke: "white",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadimage);
export default __webpack_public_path__ + "static/media/uploadimage.6441269b3060e086ec2b15c28f7958e3.svg";
export { ForwardRef as ReactComponent };